import { css } from '@emotion/react';
import { colorsLightCssVariables } from '../../common/Colors';

export const lightTheme = css`
  [data-theme='light'] {
    ${colorsLightCssVariables};
  }
`;
